import { gql } from '@apollo/client'

export const CREATE_EMAIL_TEMPLATE_MUTATION = gql`
  mutation CreateEmailTemplate($title: String!, $subject: String, $bodyHtml: String!) {
    createEmailTemplate(title: $title, subject: $subject, bodyHtml: $bodyHtml) {
      emailTemplate {
        id
        title
        subject
        bodyHtml
        createdAt
      }
      errors
    }
  }
`
